import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import type { KpiData } from '../data/mockSpaceRevenue'
import { DollarSign, PieChart, TrendingUp, AlertTriangle } from 'lucide-react'

export const KPISection = ({ data }: { data: KpiData }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
     <Card className="hover:shadow-md transition-shadow">
        <CardHeader className="flex flex-row items-center justify-between pb-2 space-y-0">
            <CardTitle className="text-sm font-medium text-muted-foreground">CONTRACTED REVENUE</CardTitle>
            <DollarSign className="w-4 h-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
            <div className="text-2xl font-bold">${data.contracted_monthly_revenue.toLocaleString()}/mo</div>
            <p className="text-xs text-muted-foreground mt-1">
                (${data.contracted_annualized.toLocaleString()}/yr)
            </p>
        </CardContent>
     </Card>

      <Card className="hover:shadow-md transition-shadow">
        <CardHeader className="flex flex-row items-center justify-between pb-2 space-y-0">
            <CardTitle className="text-sm font-medium text-muted-foreground">OCCUPANCY</CardTitle>
            <PieChart className="w-4 h-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
            <div className="text-2xl font-bold">{data.occupancy_percent_sqft}%</div>
            <div className="flex flex-col gap-0.5 mt-1">
                 <p className="text-xs text-muted-foreground">
                    sqft: {data.occupancy_percent_sqft}% ({data.occupancy_sqft_occupied.toLocaleString()}/{data.occupancy_sqft_total.toLocaleString()})
                </p>
                 <p className="text-xs text-muted-foreground">
                    units: {data.occupancy_percent_units}% ({data.occupancy_units_occupied} of {data.occupancy_units_total})
                </p>
            </div>
        </CardContent>
     </Card>

     <Card className="hover:shadow-md transition-shadow">
        <CardHeader className="flex flex-row items-center justify-between pb-2 space-y-0">
            <CardTitle className="text-sm font-medium text-muted-foreground">VACANT POTENTIAL</CardTitle>
            <TrendingUp className="w-4 h-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
             <div className="text-2xl font-bold">${data.vacant_potential_monthly.toLocaleString()}/mo</div>
             <div className="flex flex-col gap-0.5 mt-1">
                 <p className="text-xs text-muted-foreground">
                    (${data.vacant_potential_annualized.toLocaleString()}/yr)
                </p>
                <p className="text-xs text-muted-foreground">
                    {data.vacant_units_count} vacant units
                </p>
            </div>
        </CardContent>
     </Card>

     <Card className="hover:shadow-md transition-shadow">
        <CardHeader className="flex flex-row items-center justify-between pb-2 space-y-0">
            <CardTitle className="text-sm font-medium text-muted-foreground">EXPIRING (90 DAYS)</CardTitle>
            <AlertTriangle className="w-4 h-4 text-amber-500" />
        </CardHeader>
        <CardContent>
            <div className="text-2xl font-bold">{data.expiring_count_90_days} contracts</div>
             <p className="text-xs text-muted-foreground mt-1 text-amber-600 font-medium">
                ${data.expiring_revenue_risk.toLocaleString()}/mo at risk
            </p>
        </CardContent>
     </Card>
  </div>
)
